import { render } from "./Writing.vue?vue&type=template&id=1baa1360&scoped=true"
import script from "./Writing.vue?vue&type=script&lang=js"
export * from "./Writing.vue?vue&type=script&lang=js"

import "./Writing.vue?vue&type=style&index=0&id=1baa1360&lang=stylus&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1baa1360"]])

export default __exports__